import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useTimeTrackingActivityCompilationDeleteHandler(timeTrackingActivityCompilation) {
  return useEntityDeleteHandler(EntityName.TimeTrackingActivityCompilation, timeTrackingActivityCompilation, _temp);
}
function _temp(compilation) {
  return compilation.name;
}